import config from '../../config-environments/config';

const EIN_REGEX = /^[1-9]\d?-\d{7}$/;

export default EIN_REGEX;

if (config.isAngularEnabled) {
  angular
    .module('kareo.ui.shared.modules.regex.ein-regex', [])
    .constant('EIN_REGEX', EIN_REGEX);
}
